import { MaterialIcon } from "@website/icons/material";
import { Button } from "@website/ui/button";
import { CountDownTimer } from "@website/ui/count-down-timer";
import { DigitalTextField } from "@website/ui/digital-text-field";
import { Loading } from "@website/ui/loading";
import { numberConvert } from "@website/utils/number-convert";
import { replaceSnappTripBasedOnChannel } from "@website/utils/title-replace";
import { Header } from "@website/widget/login/components";
import { useOtpCard } from "@website/widget/login/components/otp-card/otp-card.hook";
import styles from "@website/widget/login/components/otp-card/otp-card.module.scss";
import { OtpCardPropertiesType } from "@website/widget/login/components/otp-card/otp-card.types";
import { FC, FormEvent, useEffect } from "react";
export const OtpCard: FC<OtpCardPropertiesType> = properties => {
  const {
    onClose,
    userData,
    isWelcomeScreen
  } = properties;
  const {
    otp,
    onChangeOtp,
    onSubmitOtp,
    isLoading,
    error,
    showSendAgain,
    onClickSendAgain,
    isLoadingSendAgain,
    onTimerEnd,
    onBackClick,
    onSubmitOtpForgotPassword,
    onClickSupport,
    onClickSendAgainByCall,
    isLoadingSendAgainByCall
  } = useOtpCard(properties);
  const remainedTime = () => {
    const now = Date.now();
    try {
      if (userData?.otpValidUntil) {
        return Math.floor(userData?.otpValidUntil - now / 1000) || 120;
      }
      return 120;
    } catch {
      return 120;
    }
  };
  const onSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (isLoading) {
      return;
    }
    if (userData?.forgotPassword) {
      onSubmitOtpForgotPassword(event);
      return;
    }
    onSubmitOtp(event);
  };
  useEffect(() => {
    const input = document.querySelector("input");
    const handleFocus = () => {
      window?.scrollTo(0, document.body.scrollHeight + 50);
    };
    input?.addEventListener("focus", handleFocus);
    return () => {
      input?.removeEventListener("focus", handleFocus);
    };
  }, []);
  return <div className={styles["container"]}>
      <Header onBack={onBackClick} onClose={onClose} title="وارد کردن کد تایید" />
      <div className={styles["title"]}>
        {`کد دریافت شده به شماره ${numberConvert(userData?.phoneNumber, {
        locale: "fa"
      })} را وارد کنید.`}
      </div>
      {/*{!isWelcomeScreen && (*/}
      {/*  <div className="text-caption py-1">*/}
      {/*    کد در پیام رسان «بله» نیز برایتان ارسال شده است.*/}
      {/*  </div>*/}
      {/*)}*/}
      <div className={styles["sub-title"]}>
        شماره موبایل اشتباه است؟
        <Button color="secondary" onClick={onBackClick} size="small" variant="text">
          ویرایش
        </Button>
      </div>
      <form className="w-full" onSubmit={onSubmit}>
        <div className={styles["input"]}>
          <DigitalTextField error={Boolean(error)} helperText={error} num={userData?.otpLength || 5} onChange={onChangeOtp} value={otp} />
        </div>
        <div className={styles["info"]}>
          {showSendAgain ? <div className="flex w-full flex-col items-center gap-4 font-bold">
              <div className="text-on-surface-medium-emphasis">
                {"کد تایید را دریافت نکرده اید؟ "}
              </div>
              <div className="font-normal">
                یکی از روش‌های زیر را برای دریافت مجدد انتخاب کنید
              </div>
              <div className="grid w-full grid-cols-2 items-center gap-2">
                <Button StartIcon={<MaterialIcon name="message" />} color="secondary" onClick={isLoadingSendAgain ? undefined : onClickSendAgain} size="small" type="button" variant="outline">
                  {isLoadingSendAgain ? <Loading color="secondary" size="sm" /> : "ارسال پیامک"}
                </Button>
                <Button StartIcon={<MaterialIcon name="call" />} color="secondary" onClick={isLoadingSendAgainByCall ? undefined : onClickSendAgainByCall} size="small" type="button" variant="outline">
                  {isLoadingSendAgainByCall ? <Loading color="secondary" size="sm" /> : "تماس"}
                </Button>
              </div>
            </div> : <>
              {"ارسال دوباره کد تایید تا "}&nbsp;
              <CountDownTimer onTimerEnd={onTimerEnd} seconds={remainedTime()} />
            </>}
        </div>
        <div className={styles["footer"]}>
          <Button color="secondary" disabled={isLoading} fullWidth size="large" type="submit" variant="contained">
            {isLoading ? <Loading color="white" size="lg" /> : userData?.userExists ? replaceSnappTripBasedOnChannel("تایید و ورود به اسنپ‌تریپ!") : "تایید و ادامه"}
          </Button>
          {!isWelcomeScreen && <Button StartIcon={<MaterialIcon name="support_agent" />} color="secondary" fullWidth href="tel:+982192000123" onClick={onClickSupport} role="link" size="large" type="button" variant="text">
              تماس با پشتیبانی (۱۲۳ ۰۰۰ ۹۲ ۰۲۱)
            </Button>}
        </div>
      </form>
    </div>;
};